import { GraphUtils } from '../utils.service';
import { StatsService } from '../../stats/stats.service';
import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from "highcharts";
import Highcharts_accessibility from 'highcharts/modules/accessibility'
import { BehaviorSubject } from 'rxjs';
import { LoggerService } from '@teammood/shared/util/logger';
import { ChartConstructorType } from "highcharts-angular";

@Component({
    selector: "usage",
    templateUrl: "./usage.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsageComponent implements OnChanges {

    @Input() query: string;
    usageChartConfigData: any;

    constructor(
        private statsService: StatsService,
        private graphUtils: GraphUtils,
        private translateService: TranslateService,
        private logger: LoggerService
    ) {
    }

    chartOptions$ = new BehaviorSubject<Highcharts.Options>({});
    chartConstructor: ChartConstructorType = 'chart';

    ngOnChanges() {
        if (this.query) {
            this.statsService.usage(this.query).then(usageData => {

                this.usageChartConfigData = this.usageChartConfig(usageData);

                this.chartOptions$.next(this.usageChartConfigData);

            }).catch(error => {
                this.logger.error(error);
            });
        }
    }

    private percentage(usages, name, total) {
        return Math.round((usages[name] || 0) / total * 100);
    };



    private usageChartConfig(usage) {

        let total = 0;

        if (usage) {
            total = (usage['regular'] || 0) + (usage['occasional'] || 0) + (usage['noResponse'] || 0);
        }

        const getMessage = (query) => {
            let message = '';
            const y = usage ? (usage[query] || 0) : 0;
            switch (query) {
                case 'regular': {
                    const rate = this.percentage(usage, 'regular', total);
                    message = y + ' ' + this.translateService.instant('analytics_usage_chart_gave_past_7_days') + '<br/>' + rate + '% ' + this.translateService.instant('of') + ' ' + total + ' ' + this.translateService.instant('teamMembers');
                    break;
                }
                case 'occasional': {
                    const rate = this.percentage(usage, 'occasional', total);
                    message = y + ' ' + this.translateService.instant('analytics_usage_chart_gave_past_month') + '<br/>' + rate + '% ' + this.translateService.instant('of') + ' ' + total + ' ' + this.translateService.instant('teamMembers');
                    break;
                }
                case 'noResponse': {
                    const rate = this.percentage(usage, 'noResponse', total);
                    message = y + ' ' + this.translateService.instant('analytics_usage_chart_gave_more_than_a_month') + '<br/>' + rate + '% ' + this.translateService.instant('of') + ' ' + total + ' ' + this.translateService.instant('teamMembers');
                    break;
                }
                default:
                    message = '';
            }
            return message;
        }

        return {
            chart: {
                type: 'bar',
                backgroundColor: this.graphUtils.graphBackgroundColor,
            },
            title: {
                text: null
            },
            subtitle: {
                text: this.translateService.instant('analytics_usage_chart_title')
            },
            xAxis: {
                categories: [this.translateService.instant('analytics_usage_chart_xaxis')]
            },
            yAxis: {
                min: 0,
                title: {
                    text: null,
                }
            },
            legend: {
                reversed: true
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true,
                        format: '{point.y:.1f}%'
                    }
                }
            },
            series: [
                {
                    name: this.translateService.instant('analytics_usage_chart_more_than_a_month'),
                    tooltip: {
                        headerFormat: null,
                        pointFormatter: function () {
                            return getMessage('noResponse');
                        }
                    },
                    color: this.graphUtils.colours('average'),
                    data: [{
                        y: this.percentage(usage, 'noResponse', total)
                    }]
                }, 
                {
                    name: this.translateService.instant('analytics_usage_chart_past_month'),
                    tooltip: {
                        headerFormat: null,
                        pointFormatter: () => {
                            return getMessage('occasional');
                        }
                    },
                    color: this.graphUtils.colours('good'),
                    data: [{
                        id: 2,
                        y: this.percentage(usage, 'occasional', total)
                    }]
                }, 
                {
                    name: this.translateService.instant('analytics_usage_chart_past_7_days'),
                    tooltip: {
                        headerFormat: null,
                        pointFormatter: () => {
                            return getMessage('regular');
                        }
                    },
                    color: this.graphUtils.colours('excellent'),
                    data: [{
                        id: 1,
                        y: this.percentage(usage, 'regular', total)
                    }]
                }
            ]
        }
    }
}
